module.exports = __webpack_public_path__ + "img/pPxW.3e371ab8.png";